/** Типы потоков работы с разными баннерами */
export enum EBannerSource {
  /** Данные получены из Adfox */
  Adfox = 'adfox',
  /** Adfox не используется */
  Internal = 'internal',
}
